import { createSlice } from "@reduxjs/toolkit"

const initialState = {
    paramData: {
        sizeName: '',
        pageNum: 1,
        pageSize: 10,
		sizeType: 1
    }
}

const reducers = {
    setParamData: (state, action) => ({
        ...state,
        paramData: {
            ...state.paramData,
            ...action.payload
        }
    })
}

const robotQaSizeSlice = createSlice({
    name: 'robotQaSize',
    initialState,
    reducers
})

export const {
    setParamData
} = robotQaSizeSlice.actions

export const getParamData = state => state.robotQaSize.paramData

export default robotQaSizeSlice
